import type {
  Suggestion,
  SingleSuggestion,
  SuggestionNodeType,
} from "@/components/suggestions/types";
import type { DocumentModel } from "@/models/DocumentModel";

const previewMap: {
  [T in SuggestionNodeType]: (suggestion: SingleSuggestion<T>, doc?: DocumentModel) => boolean;
} = {
  number: () => true,
  variable: () => true,
  constant: () => true,
  function: () => true,
  operator: () => false,
  group: ({ icon }) => !icon,
  operatorSymbol: () => true,
  plainText: () => true,
  symbol: () => true,
  expression: () => true,
  library: () => true,
  placeholder: () => true,
  sympyAction: () => true,
  slashCommand: () => false,
  inlineTextStyle: () => false,
};

export function checkShouldRenderPreviewAsRealNode<T extends SuggestionNodeType>(
  suggestion: Suggestion<T>,
  doc?: DocumentModel,
): boolean {
  if (suggestion.type === "multi") {
    return true;
  }

  if (suggestion.type !== "single") {
    return false;
  }

  if (suggestion.forceIcon || suggestion.nodePreviewPlacement === "afterTitle") {
    return false;
  }

  const shouldRenderPreviewAsRealNode = previewMap[suggestion.item.type]?.(suggestion, doc);
  return shouldRenderPreviewAsRealNode;
}
